import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup, FormsModule } from "@angular/forms";
import { CreateFinishedGoodsTemplateComponent } from "../create-finished-goods-template/create-finished-goods-template.component";
import { AddExistingFinishedGoodsTemplateComponent } from "../add-existing-finished-goods-template/add-existing-finished-goods-template.component";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { RadioButtonModule } from "primeng/radiobutton";

@Component({
  selector: "jni-finished-goods-template",
  templateUrl: "./finished-goods-template.component.html",
  styleUrls: ["./finished-goods-template.component.scss"],
  imports: [
    CreateFinishedGoodsTemplateComponent,
    AddExistingFinishedGoodsTemplateComponent,
    CommonModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    RadioButtonModule,
    FormsModule,
  ],
})
export class FinishedGoodsTemplateComponent {
  @Input() parent!: FormGroup;
  @Input() saleOrderIdFromModal = "";
  @Input() lineGroup = "";
  @Input() site = "";
  @Input() warehouse = "";
  @Input() jobNameD365 = "";
  @Input() wMSLocationD365 = "";
  @Input() saleOrderModalStatus = false;
  @Input() owner = "";
  @Input() store = "";

  @Output() refreshGridEmit = new EventEmitter();
  @Output() closeModalEmit = new EventEmitter();

  templateType = "existing";

  templateTypeChange(value: string) {
    this.templateType = value;
  }

  closeModal() {
    this.closeModalEmit.emit();
  }
}
